import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { errMessage } from './tool'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status_code === 401 || res.status_code === 403) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload()    // 为了重新实例化vue-router对象 避免bug
        })
      })
      return Promise.reject('error')
    } else if (res.status_code === 500) {
      Message({
        message: res.message || res.desc || '请求失败',
        type: 'error',
        duration: 3 * 1000
      })
      // 兼容go返回数据
    }else if(response.data.data) {
      const { page, pageSize, total } = response.data.data
      const totalPage = { page, pageSize, total }
      if(pageSize) response.data.data['totalPage'] = totalPage
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    errMessage(error.response.data)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js